// extracted by mini-css-extract-plugin
export var header = "_vm-1";
export var maskBottom = "_vm-6";
export var maskMiddle = "_vm-7";
export var maskTop = "_vm-5";
export var root = "_vm-0";
export var scrollDownButton = "_vm-3";
export var scrollDownButtonHidden = "_vm-4";
export var viewport = "_vm-2";